<script>
  let { text, align = 'left' } = $props();
</script>

<div class="receipt-label" style:text-align={align}>
  {text}
</div>

<style>
  .receipt-label {
    font-family: var(--font-mono);
    font-size: var(--receipt-size-label);
    font-weight: var(--font-weight-medium);
    color: var(--receipt-text-secondary);
    text-transform: uppercase;
    letter-spacing: var(--receipt-ls-label);
    margin-bottom: 8px;
    line-height: var(--line-height-normal);
  }
</style>
